<template>
  <div class="profilefile-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('profilefile_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-file-cog-outline</v-icon>{{$t('profile.profilefiles')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ProfileFileFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
          
          <template v-slot:item.machines="{ item }">
            <ul v-if="item.machines && item.machines.length">
              <li v-for="machine in item.machines" :key="machine.id">{{ machine.name }}</li>
            </ul>
          </template>
          <template v-slot:item.toolheads="{ item }">
            <ul v-if="item.toolheads && item.toolheads.length">
              <li v-for="toolhead in item.toolheads" :key="toolhead.id">{{ toolhead.name }}</li>
            </ul>
          </template>
          <template v-slot:item.softwares="{ item }">
            <ul v-if="item.softwares && item.softwares.length">
              <li v-for="software in item.softwares" :key="software.id">{{ software.name }}</li>
            </ul>
          </template>

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ProfileFileFilterForm from '../../components/profilefile/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ProfileFileList',
  servicePrefix: 'ProfileFile',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    ProfileFileFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.reference'), value: 'reference' },
        { text: this.$t('profile.version'), value: 'version' },
        { text: this.$t('profile.material.manufacturer'), value: 'materialManufacturer.name' },
        { text: this.$t('profile.machine.compatiblesMachines'), value: 'machines' },
        { text: this.$t('profile.machine.compatiblesToolheads'), value: 'toolheads' },
        { text: this.$t('profile.software.softwares'), value: 'softwares' },
        { text: this.$t('qualitycheck.customer.tags'), value: 'tags' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
      footer: {
        'itemsPerPageText': "",
      },

    };
  },
  computed: {
    ...mapGetters('profilefile', {
      items: 'list'
    }),
    ...mapFields('profilefile', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('profilefile', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
